(function () {
  function getThemeHeader() {
    return document.querySelector('.cc-header--sticky') || document.querySelector('.shopify-section-group-header-group');
  }
  function getOurNav() {
    return document.querySelector('.fs-jmp-nav');
  }
  let ticking = false;
  function syncOffset() {
    const themeHeader = getThemeHeader();
    const bottom = themeHeader ? Math.max(0, themeHeader.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--fs-jmp-header-offset', bottom + 'px');

    const ourNav = getOurNav();
    const navHeight = ourNav ? ourNav.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--fs-jmp-scroll-offset', (bottom + navHeight + 16) + 'px');

    ticking = false;
  }
  function onScrollOrResize() {
    if (!ticking) {
      requestAnimationFrame(syncOffset);
      ticking = true;
    }
  }
  syncOffset();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  if (window.ResizeObserver) {
    const ro = new ResizeObserver(onScrollOrResize);
    const initialHeader = getThemeHeader();
    if (initialHeader) ro.observe(initialHeader);
    const initialNav = getOurNav();
    if (initialNav) ro.observe(initialNav);
  }
  setInterval(syncOffset, 500);
})();

const cards = document.querySelectorAll('.fs-jmp-package-card');
    const bar = document.getElementById('selected-plan');
    const title = document.getElementById('selected-title');
    const detail = document.getElementById('selected-detail');
    const planInput = document.getElementById('selected-plan-input');
    cards.forEach(card => {
      card.addEventListener('click', () => {
        cards.forEach(c => c.classList.remove('fs-jmp-package-card--selected'));
        card.classList.add('fs-jmp-package-card--selected');
        const duration = card.dataset.duration;
        const reach = card.dataset.reach;
        const total = card.dataset.total;
        const perCampaign = card.dataset.perCampaign;
        const perContact = card.dataset.perContact;
        title.textContent = `${duration} · ${reach} contacts · ${total} ex VAT`;
        detail.textContent = `${perCampaign} per campaign · ${perContact} per contact`;
        planInput.value = `${duration}, ${reach} contacts, ${total} ex VAT, ${perCampaign} per campaign, ${perContact} per contact`;
        bar.classList.add('fs-jmp-plan-bar--visible');
      });
    });

(function () {
  const ENDPOINT = 'https://script.google.com/macros/s/AKfycbz-JvuvHbOSVdVhGf5n3c76skSOrrzDSjfRHTBC01emoL9wtYeAcyjiPQ0HKOc31PaWGg/exec';
  const form = document.getElementById('jma-enquiry');
  const status = document.getElementById('jma-status');
  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    status.dataset.state = 'sending';
    status.textContent = 'Sending your enquiry…';

    const formData = new FormData(form);

    fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', body: formData })
      .then(function () {
        status.dataset.state = 'success';
        status.textContent = 'Thank you — your enquiry has been received. We will be in touch shortly.';
        form.reset();
        submitBtn.disabled = false;
      })
      .catch(function () {
        status.dataset.state = 'error';
        status.textContent = 'Something went wrong sending your enquiry. Please try again or email us directly.';
        submitBtn.disabled = false;
      });
  });
})();
